
namespace RioERP.Invoices {
    export class InvoicesColumns {
        static columnsKey = 'Invoices.Invoices';
    }
}